<kui-modal [loading]="loading" [title]="'DASHBOARDS.REPORT_VIEWER' | translate" [actions]="actions" size="fill" (onClose)="detachModal()">
    @if (report) {
        <key-analytics
            class="d-flex flex-1 w-100"
            [report]="report"
            [isMobile]="isMobile"
            [visibleSettings]="visibleSettings"
            [showSettings]="showAnalyticsSettings"
            (onGraphShared)="handleSharedWidget($event)"
            (onSettingsVisiblityToggle)="isMobile && (showAnalyticsSettings = $event)"
        ></key-analytics>
    }
</kui-modal>
